import { Action, ActionSubject, type FeatureEvents, type ScreenEvent, type UIEvent } from '../new-analytics-types';

const unifiedGroupListScreen = 'unifiedGroupListScreen';

type ScreenKeys = 'unifiedGroupListScreen';
type UiKeys = 'createGroupButtonClicked';

export const unifiedGroupListEvents: FeatureEvents<ScreenKeys, UiKeys, never, never> = {
  confluenceSpec: 'https://hello.atlassian.net/wiki/spaces/CLOUDADMIN/pages/5243879670/Analytics+Spec+Groups+List+M1',
  screen: {
    unifiedGroupListScreen: ({ totalGroupCount }: { totalGroupCount: number }): ScreenEvent => ({
      data: {
        name: unifiedGroupListScreen,
        attributes: {
          totalGroupCount,
        },
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/86636',
    }),
  },
  ui: {
    createGroupButtonClicked: (): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'createGroupButton',
        source: unifiedGroupListScreen,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/13401',
    }),
  },
  track: {},
  operational: {},
};
